<dialog-close-button></dialog-close-button>

<mat-dialog-content>
  <privacy-policy></privacy-policy>
</mat-dialog-content>
